@if (busy) {
    <img src="{{_localImageLocation}}ajax-loader.gif" class="form-busy" alt="loading">
}
@if (showAccounts) {
    <div>
        <div class="accountSearch">
            <div class="tooltip">
                <input type="text" [(ngModel)]="searchCriteria" [placeholder]="searchHelpText" style="width: 200px;" (keyup.enter)="searchAccounts()" />
                <span class="tooltiptext">{{toolTip}}</span>
            </div>
            &nbsp;&nbsp;<button (click)="searchAccounts()">{{searchButtonTitle}}</button>
            @if (noResultsFound) {
                <span style="color: red; padding-left: 20px;">No results matching the search criteria were found.</span>
            }
        </div>
        <div>
            @if (pagedAccounts && pagedAccounts.length > 0) {
                <table id="accountTable">
                    @for (account of pagedAccounts[currentPage]; track account; let odd = $odd) {
                        <tr [style.background-color]="odd ? '#eeeeee' : '#ffffff'">
                            <td><a href="javascript:void(0)" (click)="accountSelected(account)">{{account.AccountNumber}}</a></td>
                            <td>{{account.Name}}</td>
                            <td>{{account.Location}}</td>
                        </tr>
                    }
                </table>
            }
        </div>
        @if (maxPages > 1) {
            <div>
                <div class="pageChanges">
                    <img src="{{_localImageLocation}}FirstRecord.png" (click)="setPage(0)" alt="first" />
                    <img src="{{_localImageLocation}}PreviousRecord.png" (click)="incrementPage(-1)" alt="previous" />
                    <span>{{currentPage + 1}}&nbsp;/&nbsp;{{maxPages}}&nbsp;&nbsp;</span>
                    <img src="{{_localImageLocation}}NextRecord.png" (click)="incrementPage(1)" alt="next" />
                    <img src="{{_localImageLocation}}LastRecord.png" (click)="setPage(maxPages - 1)" alt="last" />
                </div>
            </div>
        }
    </div>
}
